import React from 'react';
import { SellerHeader } from 'sellDirect/components/offer/SellerHeader';
import { AddressBlock } from 'sellDirect/components/offer/AddressBlock';
import { Layout, LayoutContent } from 'platform/components/layout/Layout';
import { useQualificationContext } from 'shared/helpers/QualificationContext';

export interface SellDirectLayoutProps {
  address: { street: string };
  children: React.ReactNode;
  stickyBottomContent?: React.ReactNode;
  isLoading: boolean;
}

// component-test-check-ignore
/** SellDirect-specific layout that should wrap all variants of the Sell page. */
export const SellDirectLayout: React.FC<SellDirectLayoutProps> = ({
  address,
  children,
  stickyBottomContent,
  isLoading,
}) => {
  const { customerLeads, lead } = useQualificationContext();
  return (
    <Layout
      data-testid="hub-sell-page"
      renderHeader={() => <SellerHeader title="Selling" />}
      isLoading={isLoading}
      stickyBottomContent={stickyBottomContent}
    >
      <AddressBlock address={address} customerLeads={customerLeads} lead={lead} />
      <LayoutContent>{children}</LayoutContent>
    </Layout>
  );
};
